// Domain
import { highlightTextSegments } from '../../../domain/live-search/liveSearchUseCase';

// Styles
import styles from './HighlightedText.module.css';

/**
 * Renders text with matched query terms highlighted.
 * @param {object} props
 * @param {string} props.text - Full text to display
 * @param {string[]} [props.terms=[]] - Query terms to highlight
 * @param {string} [props.className] - Additional CSS classes
 * @returns {JSX.Element}
 */
function HighlightedText({
  text,
  terms = [],
  className,
}) {
  if (!terms.length) {
    return <span className={className}>{text}</span>;
  }

  const segments = highlightTextSegments(text, terms);

  return (
    <span className={className}>
      {segments.map((segment, index) => (
        segment.matched ? (
          <mark
            // Segments are positional; text alone is not unique across repeats
            // eslint-disable-next-line react/no-array-index-key
            key={`${index}-${segment.text}`}
            className={styles.match}
          >
            {segment.text}
          </mark>
        ) : (
          // eslint-disable-next-line react/no-array-index-key
          <span key={`${index}-${segment.text}`}>{segment.text}</span>
        )
      ))}
    </span>
  );
}

export default HighlightedText;
